import * as componentTypes from "../constants/componentTypes";
import * as ticketTypes from "../constants/ticketTypes";

import imgClaim from "../resources/img/svgicons/tickets-formula-claim.svg";
import imgDispensing from "../resources/img/svgicons/dispensing2.svg";
import imgDispensingColoris from "../resources/img/svgicons/machine-coloris2.svg";
import imgFormula from "../resources/img/svgicons/tickets-formula-request.svg";
import imgHelp from "../resources/img/svgicons/help2.svg";
import imgMessage from "../resources/img/svgicons/tickets-message.svg";
import imgPrint from "../resources/img/svgicons/print2.svg";
import imgPrintColoris from "../resources/img/svgicons/print-coloris.svg";
import imgService from "../resources/img/svgicons/tickets-service.svg";

export const getSvgIcon = (iconType, colorisSoftware = false) => {
    switch (iconType) {
        case componentTypes.ICON_DISPENSE:
            if (colorisSoftware) {
                return imgDispensingColoris;
            }

            return imgDispensing;
        case componentTypes.ICON_PRINT:
            if (colorisSoftware) {
                return imgPrintColoris;
            }

            return imgPrint;
        default:
            return imgHelp;
    }
};

export const getTicketTypeIcon = (type) => {
    switch (type) {
        case ticketTypes.TICKET_TYPE_SERVICE_TICKET.id: {
            return imgService;
        }

        case ticketTypes.TICKET_TYPE_MESSAGE_TICKET.id: {
            return imgMessage;
        }

        case ticketTypes.TICKET_TYPE_FORMULA_REQUEST.id: {
            return imgFormula;
        }

        case ticketTypes.TICKET_TYPE_FORMULA_CLAIM.id: {
            return imgClaim;
        }

        default:
            return null;
    }
};
